import { useTranslation } from "react-i18next";
import styled from "styled-components";
import media from "../../styles/media";
import Container from "../ui/Container";
import { ButtonLink } from "../ui/Button";
import Spinner from "../ui/Spinner";
import ReportCard from "../reports/ReportCard";
import useReports from "../../hooks/useReports";
import { ROUTES } from "../../config/routes";

const Wrapper = styled.section`
  padding: 64px 0;
  background-color: ${({ theme }) => theme.colors.primarySoft};

  ${media.md} {
    padding: 40px 0;
  }
`;

const Head = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
`;

const Heading = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.h3};
  font-weight: 700;
`;

const Description = styled.p`
  max-width: 60ch;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-bottom: 28px;

  ${media.md} {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

const Actions = styled.div`
  display: flex;
`;

const PREVIEW_COUNT = 3;

/**
 * Блок «Отчеты» на главной: последние отчёты и переход в полный раздел.
 * Если API недоступен, показываются зашитые в код записи — блок не пустеет.
 */
export function ReportsSection() {
  const { t } = useTranslation();
  const { reports, loading } = useReports({ limit: PREVIEW_COUNT });

  return (
    <Wrapper>
      <Container>
        <Head>
          <div>
            <Heading>{t("reports")}</Heading>
            <Description>{t("reports_section_description")}</Description>
          </div>
        </Head>

        {loading && <Spinner compact label={t("loading")} />}

        {!loading && reports.length > 0 && (
          <Grid>
            {reports.map((report) => (
              <ReportCard key={report.id} report={report} headingLevel="h3" />
            ))}
          </Grid>
        )}

        <Actions>
          <ButtonLink to={ROUTES.reports}>{t("all_reports")}</ButtonLink>
        </Actions>
      </Container>
    </Wrapper>
  );
}

export default ReportsSection;
